<template>
  <div class="page" id="reset">
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div class="title flex" v-i18n>重置密码</div>
      <div class="label flex" v-i18n>真实姓名</div>
      <van-field
        v-model="form.realname"
        name="realname"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />

      <div class="label flex" v-i18n>手机号/昵称</div>
      <van-field
        v-model="form.username"
        name="username"
        placeholder="手机号/昵称"
        :rules="[{ required: true, message: '请填写手机号/昵称' }]"
      />

      <div class="label flex" v-i18n>密码</div>
      <van-field
        v-model="form.password"
        type="password"
        name="password"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />

      <div class="label flex" v-i18n>重复密码</div>
      <van-field
        v-model="repeatPWD"
        type="password"
        name="password"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="linear-gradient(to right, #ffa726, #f5793f, #f25e28)"
          >SUBMIT 提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>